$(function () {
  $('#product-img-slider').slick({
    autoPlay: true,
    arrows: false,
    dots: true,
    adaptiveHeight: false,
    dotsClass: 'dots-wrap',
    customPaging: function (slick, index) {
      var targetImage = slick.$slides.eq(index).find('img').attr('src');
      return '<img src="' + targetImage + '" alt="">';
    },
  });
});
